import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  TabWrapper
} from './styled'

class TabList extends React.PureComponent {
  render() {
    const {
      className,
      children,
      isActive,
      isDisabledClick,
      onClick,
      isHelpActive,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'tab-custom-list',
      { 'is-active': isActive },
      { 'is-disabled-click': isDisabledClick },
      { 'is-help-active': isHelpActive },

      className
    )

    return (
      <div
        className={classes}
        onClick={onClick}
        role='button'
        tabIndex={0}
        onKeyDown={() => { }}
      >
        {children}
      </div>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}

export class Tab extends React.PureComponent {
  render() {
    const {
      className,
      children,
      isThemeBlue,
      isHelpTab,
      isThemeUnderline,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'tab-custom',
      { 'is-theme-blue': isThemeBlue },
      { 'is-help-tab': isHelpTab },
      { 'is-theme-underline': isThemeUnderline },
      className
    )

    return (
      <TabWrapper
        className={classes}
      >
        {children}
      </TabWrapper>
    )
  }

  static List = TabList

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
